import SMSearchResultsLoadingIndicator from './SMSearchResultsLoadingIndicator';

export default SMSearchResultsLoadingIndicator;
